import types from "../actions/actionTypes";
import initialState from "./initialState";

export default function sideBarShowReducer(state = initialState.sidebarShow, action) {
    switch (action.type) {
        case types.UPDATE_SIDEBARSHOW:
            return action.sidebarShow;
        default:
            return state;
    }
}